import { action } from 'typesafe-actions'
import { RelevanceTypes } from './types'
import { IAxiosResponse} from '../root.types'
import { Map } from '../../application/models/map/map'

export const loadRelevanceRequest = () => action(RelevanceTypes.LOAD_RELEVANCE_REQUEST)

export const loadRelevanceSuccess = (response: IAxiosResponse<Map[]>) => action(
    RelevanceTypes.LOAD_RELEVANCE_SUCCESS, response
)

export const loadRelevanceFailure = () => action(RelevanceTypes.LOAD_RELEVANCE_FAILURE)

